import { Route, Routes } from 'react-router-dom';

import './App.css';
import { PrivateRoute } from './components/CustomRoutes/PrivateRoute';
import { PublicRoute } from './components/CustomRoutes/PublicRoute';
import Dashboard from './screens/Dashboard';
import Login from './screens/Login';
import SignupRevamp from './screens/SignupRevamp';
import NotFound from './screens/NotFound';
import CreatePatient from './screens/Patients/CreatePatient';
import PatientDashboard from './screens/Patients/Dashboard';
import DiseaseDetails from './screens/Patients/DiseaseDetails';
import Diseases from './screens/Patients/Diseases';
import Genotype from './screens/Patients/Genotype';
import PatientProfile from './screens/Patients/PatientProfile';
import Patients from './screens/Patients/Patients';
import Tests from './screens/Patients/Tests';
import TestBooking from './screens/TestBooking';
import LandingPage from './screens/LandingPage';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<PublicRoute element={LandingPage} />} />
      <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} />
      {/* patients */}
      <Route path="/patients" element={<PrivateRoute element={Patients} />} />
      <Route
        path="/patients/:patientguid"
        element={<PrivateRoute element={PatientProfile} />}
      />
      <Route
        path="/patients/create"
        element={<PrivateRoute element={CreatePatient} />}
      />
      <Route
        path="/patients/create/:patientguid"
        element={<PrivateRoute element={CreatePatient} />}
      />
      <Route
        path="/patients/diseases/:patientguid"
        element={<PrivateRoute element={Diseases} />}
      />
      <Route
        path="/patients/diseasedetails/:patientguid/:diseaseName"
        element={<PrivateRoute element={DiseaseDetails} />}
      />
      <Route
        path="/testbooking"
        element={<PrivateRoute element={TestBooking} />}
      />
      <Route
        path="/patients/genotype/:patientguid"
        element={<PrivateRoute element={Genotype} />}
      />
      <Route
        path="/patients/tests/:patientguid"
        element={<PrivateRoute element={Tests} />}
      />
      <Route
        path="/patients/dashboard/:patientguid"
        element={<PrivateRoute element={PatientDashboard} />}
      />
      <Route path="/testing" element={<PatientProfile />}></Route>

      {/* others */}
      <Route path="/login" element={<PublicRoute element={Login} />} />
      <Route path="/signup" element={<PublicRoute element={SignupRevamp} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
